import React, { useState, useEffect } from 'react';
import { injectIntl } from 'react-intl';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { useHistory } from 'react-router-dom';
import { Link } from 'react-router-dom';

import { Button, NewCheckbox } from 'components';
import ReviewContainer from '../containers/review';
import defaultBag from 'constants';
import defaultSender from 'constants';
import messages from 'messages';

function Review({ ...props }) {
    const queryClient = useQueryClient();

    const transactionMutation = useMutation('transaction-mutation');

    const history = useHistory();
    const { formatMessage } = props.intl;

    const [accept, setAccept] = useState(false);

    const transaction = useQuery('transaction')?.data || {};
    const { domain, id } = queryClient.getQueryData('restaurant') || '';
    const bag = queryClient.getQueryData('bag') || defaultBag;
    const sender = queryClient.getQueryData('sender') || defaultSender;

    const createTransaction = () => {
        if (bag.length) {
            const data = {
                restaurant: id,
                user: {
                    name: `${sender.firstName} ${sender.lastName}`,
                    email: sender.email,
                },
                deliveryMethod: 'email-sender',
                items: [],
            };

            const temp = [];
            bag.forEach((item) => {
                let giftCard = {
                    type: item.type,
                    amount: parseFloat(item.amount),
                    quantity: item.quantity,
                };

                item.recipients.forEach((recipient) => {
                    giftCard.recipient = {
                        name: recipient.name,
                        email: recipient.email,
                    };
                    giftCard.notes = recipient.message;
                });

                if (item.sameReceiver) {
                    giftCard.notes = item.recipients[0].message;
                    giftCard.recipient = {
                        name: item.recipients[0].name,
                        email: item.recipients[0].email,
                    };
                }

                if (item.type === 'experience') {
                    giftCard.experience = item.experienceId;
                }

                temp.push(giftCard);

                data.items = temp;
            });

            transactionMutation.mutate(data);
        }
    };

    useEffect(() => {
        if (transaction.id) {
            localStorage.setItem('transaction', JSON.stringify(transaction));
            history.push(`/${domain}/${transaction.id}/payment`);
        }
    }, [transaction]);

    if (!bag.length) {
        history.push(`/${domain}/choose`);
    }

    return (
        <div className="page-wrapper page-review">
            <h2 className="title">{formatMessage(messages.reviewTitle)}</h2>

            <ReviewContainer />

            <div className="wrapper terms">
                <NewCheckbox
                    checked={accept}
                    label={
                        <span data-test="i-accept">
                            <Link to={`/${domain}/terms`}>
                                {formatMessage(messages.reviewTermsOfUse)}
                            </Link>
                        </span>
                    }
                    onChange={(value) => setAccept(value)}
                    data-test="check-terms"
                />
            </div>
            <div className="wrapper">
                <Button
                    disabled={!accept}
                    onClick={() => createTransaction()}
                    data-test="button-continue"
                >
                    {transaction.isLoading
                        ? formatMessage(messages.genericLabelWait)
                        : formatMessage(messages.genericButtonContinue)}
                </Button>
            </div>
        </div>
    );
}

export default injectIntl(React.memo(Review));
